
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inheritance-management",
      function () {
        return require("private-next-pages/inheritance-management.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inheritance-management"])
      });
    }
  